export const ModalTerms = () => {
    return (
        <>
            <h2 className={'text-2xl font-semibold text-indigo-700'}>Chính sách bảo vệ dữ liệu cá nhân</h2>
            <div className={'section1 space-y-2 gap-4 mt-4'}>
                <h4 className={'text-lg font-semibold px-12'}>1. Tổng quan</h4>
                <p className={'text-md'}>
                    Pacific (“chúng tôi”) cam kết tôn trọng quyền riêng tư của Quý khách hàng. Chúng tôi cố gắng cung
                    cấp trải nghiệm người dùng an toàn, bảo mật. Chính sách bảo vệ dữ liệu cá nhân (sau đây gọi là
                    “Chính sách”) nêu rõ việc thu thập, xử lý và sử dụng dữ liệu cá nhân trực tuyến áp dụng cho tất cả
                    những trang web của chúng tôi (trừ khi có một tuyên bố riêng về quyền riêng tư áp dụng cụ thể).
                    Chúng tôi khuyến khích Quý khách hàng đọc kỹ Chính sách này và thường xuyên kiểm tra trang này để
                    xem xét bất kỳ thay đổi nào chúng tôi có thể thực hiện theo các điều khoản của Chính sách này.
                </p>
                <p>Với mục đích của Chính sách này, dữ liệu cá nhân có nghĩa là bất kỳ thông tin nào liên quan đến một
                    thể nhân được xác định hoặc có thể nhận dạng (tức là một cá nhân).</p>
                <p>Bằng cách chọn và đồng ý với Chính sách bảo vệ dữ liệu cá nhân, Quý khách hàng cho phép chúng tôi thu
                    thập, sử dụng, và/hoặc xử lý dữ liệu cá nhân của Quý khách hàng theo quy định tại Chính sách này.
                    Việc cho phép này sẽ có hiệu lực và giá trị từ thời điểm Quý khách hàng đồng ý cho đến khi chấm dứt
                    theo quy định của pháp luật. Nếu Quý khách hàng không đồng ý cho phép việc xử lý dữ liệu cá nhân của
                    Quý khách hàng như mô tả trong Chính sách này, xin vui lòng không sử dụng dịch vụ của chúng tôi hoặc
                    truy cập các trang web của chúng tôi.</p>
                <p>Dữ liệu cá nhân của Quý khách hàng sẽ được lưu trữ và xử lý toàn bộ hoặc một phần tại Việt Nam và các
                    quốc gia khác trên thế giới. Nếu Quý khách hàng truy cập trang web của Pacific từ các quốc gia
                    khác ngoài Việt Nam, việc Quý khách hàng sử dụng trang web này đồng nghĩa với việc Quý khách hàng
                    đồng ý chuyển dữ liệu của Quý khách hàng ra khỏi quốc gia của Quý khách hàng và đến Việt Nam.</p>
                <p>Lưu ý: Các trang web của chúng tôi có chứa liên kết đến các trang web khác mà chúng tôi không kiểm
                    soát. Pacific không chịu trách nhiệm về chính sách quyền riêng tư hoặc cách hoạt động của các
                    trang web khác mà Quý khách hàng chọn kết nối từ một trang web của Pacific. Chúng tôi khuyến khích
                    Quý khách hàng xem xét các chính sách quyền riêng tư của những trang web khác đó để Quý khách hàng
                    có thể hiểu cách họ xử lý, sử dụng và chia sẻ dữ liệu cá nhân của Quý khách hàng.</p>
            </div>
            <div className={'section2 space-y-4 gap-4 mt-4'}>
                <h4 className={'text-lg font-semibold px-12'}>2. Các loại dữ liệu cá nhân và cách thu thập</h4>
                <div className={'text-md space-y-4'}>
                    <p>Quý khách hàng hiểu, xác nhận và đồng ý rằng Pacific được phép xử lý dữ
                        liệu cá nhân của Quý khách hàng, người được Quý khách hàng ủy quyền và các bên khác có liên quan
                        của
                        Quý khách hàng, nếu cung cấp hoặc liên hệ với Pacific, bao gồm các dữ liệu cá nhân được cập
                        nhật,
                        sửa đổi, bổ sung tại từng thời điểm, trong đó:</p>
                    <li className={'ms-12'}>
                        Dữ liệu được thu thập có thể bao gồm: Họ tên, ngày tháng năm sinh, giới tính, nơi sinh, địa chỉ
                        thường trú, địa chỉ liên hệ, quốc tịch, hình ảnh, số điện thoại, email, các loại giấy tờ tùy
                        thân, thông tin về tài khoản số, dữ liệu cá nhân phản ánh hoạt động, lịch sử hoạt động trên
                        không gian mạng, các thông tin, dữ liệu khác gắn liền với cá nhân hoặc giúp xác định một cá nhân
                        cụ thể và các thông tin, dữ liệu khác theo quy định của pháp luật;
                    </li>
                    <li className={'ms-12'}>
                        Và trong một số trường hợp, chúng tôi có thể phải thu thập thêm một số dữ liệu cá nhân liên quan
                        đến tình trạng sức khỏe, mối quan hệ trong gia đình, tình trạng công việc, một số thông tin khác
                        được phân vào nhóm dữ liệu cá nhân nhạy cảm theo khoản 4 điều 2 Nghị định 13/2023/NĐ-CP.
                    </li>
                    <p>Quý khách hàng cũng đồng ý và xác nhận rằng tất cả dữ liệu cá nhân và thông tin mà Quý khách hàng
                        cung cấp, đăng hoặc tải lên trên trang web của chúng tôi là chính xác và hợp pháp, và Quý khách
                        hàng không sử dụng dữ liệu và thông tin như vậy cho bất kỳ mục đích bất hợp pháp nào. Pacific,
                        hoạt động như một nền tảng trung gian, sẽ không cung cấp bất kỳ bảo đảm nào và không chịu trách
                        nhiệm cho bất kỳ bên nào liên quan đến vấn đề này.</p>
                    <p>
                        Nếu Quý khách hàng cung cấp cho chúng tôi bất kỳ dữ liệu cá nhân của bất kỳ bên thứ ba nào, Quý
                        khách hàng cam kết và đảm bảo rằng Quý khách hàng đã có được sự đồng ý, giấy phép và/hoặc sự cho
                        phép từ bên thứ ba đó để chia sẻ và chuyển dữ liệu cá nhân của họ cho chúng tôi, và để chúng tôi
                        thu thập, lưu trữ, sử dụng, tiết lộ và/hoặc xử lý dữ liệu đó theo Chính sách này.
                    </p>
                </div>
            </div>
            <div className={'section3 space-y-4 gap-4 mt-4'}>
                <h4 className={'text-lg font-semibold px-12'}>3. Điều khoản thanh toán <span
                    className={'text-red-500'}>(*)</span></h4>
                <p>
                    <li>
                        Quý khách hàng đồng ý thanh toán toàn bộ giá trị của tour hoặc dịch vụ mà Quý khách hàng đặt
                        mua.
                    </li>
                    <li>
                        Chúng tôi sẽ hợp tác và chấp nhận các lý do hoàn tiền <span className={'text-red-500'}>nếu như Quý khách gửi/hủy hoàn tiền trước 1 tuần</span>
                        Đồng thời các giá tiền đã được bao gồm các giá phụ thu, giá dịch vụ, giá tour, giá vé máy bay,
                        giá khách sạn, giá ăn uống, giá vận chuyển, giá phí tham quan, giá phí hướng dẫn viên, giá phí
                        bảo hiểm, giá phí visa, giá phí phục vụ, giá phí khác.
                    </li>
                </p>
            </div>
            <div className={'section4 space-y-4 gap-4 mt-4'}>
                <h4 className={'text-lg font-semibold px-12'}>4. Thông tin liên hệ</h4>
                <p>
                    <li>
                        Nếu Quý khách hàng có bất kỳ câu hỏi hoặc yêu cầu nào về Chính sách bảo vệ dữ liệu cá nhân, vui
                        lòng liên hệ với chúng tôi qua email: <span className={'text-red-500'}>
                        <a href={'mailto:pacific.musketeers.tni@gmail.com'}>Gửi mail cho chúng tôi</a>
                    </span>
                    </li>
                </p>
            </div>
        </>
    );
};